import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useContext } from 'react';
import { styled } from '@classify/react-core-components/styles';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Paper, useMediaQuery } from '@mui/material';
import { useTheme } from '@classify/react-core-components/styles';
import SearchForm from './SearchForm';
import SelectedPeople from './SelectedPeople';
import SearchContext from './SearchContext';
const PREFIX = 'TopBar';
const classes = {
  root: `${PREFIX}-root`,
  top: `${PREFIX}-top`,
  mobileSearchButton: `${PREFIX}-mobileSearchButton`,
  mobileBackButton: `${PREFIX}-mobileBackButton`,
  resetButton: `${PREFIX}-resetButton`,
  formContainer: `${PREFIX}-formContainer`
};
const StyledPaper = styled(Paper)(/* istanbul ignore next */({
  theme: {
    spacing,
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    padding: spacing(1.5, 1.5, 1.5, 1.5)
  },
  [`& .${classes.top}`]: {
    height: 40,
    position: 'relative'
  },
  [`& .${classes.mobileSearchButton}`]: {
    position: 'absolute',
    top: spacing(-0.5),
    right: spacing(-0.5),
    zIndex: 1,
    color: palette.text.main
  },
  [`& .${classes.mobileBackButton}`]: {
    position: 'absolute',
    top: spacing(-0.5),
    left: spacing(-0.5),
    zIndex: 1,
    color: palette.text.main
  },
  [`& .${classes.resetButton}`]: {
    top: -4,
    left: -4,
    zIndex: 1,
    color: palette.text.main
  },
  [`& .${classes.formContainer}`]: {
    boxSizing: 'border-box',
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0
  }
}));
export default function TopBar(t0) {
  const $ = _c(40);
  const {
    onCancel: t1,
    onConfirmSelected: t2,
    translations
  } = t0;
  const onCancel = t1 === undefined ? _temp : t1;
  const onConfirmSelected = t2 === undefined ? _temp2 : t2;
  const {
    breakpoints
  } = useTheme();
  const {
    onQueryChange,
    selected,
    hasEmptyPeopleList
  } = useContext(SearchContext);
  let t3;
  if ($[0] !== breakpoints) {
    t3 = breakpoints.down("lg");
    $[0] = breakpoints;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isCompactMode = useMediaQuery(t3);
  const [isFieldShown, toggleField] = useState(!isCompactMode);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CloseIcon />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onCancel || $[4] !== translations.cancelButtonLabel) {
    t5 = <IconButton color="inherit" className={classes.resetButton} onClick={onCancel} aria-label={translations.cancelButtonLabel} size="large">{t4}</IconButton>;
    $[3] = onCancel;
    $[4] = translations.cancelButtonLabel;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const closeButton = t5;
  let t6;
  if ($[6] !== isFieldShown || $[7] !== translations) {
    t6 = translations.toggleSearchFieldLabel({
      isFieldShown
    });
    $[6] = isFieldShown;
    $[7] = translations;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onQueryChange) {
    t7 = () => {
      toggleField(_temp3);
      onQueryChange("");
    };
    $[9] = onQueryChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArrowBackIcon />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t7) {
    t9 = <IconButton aria-label={t6} color="inherit" className={classes.mobileBackButton} onClick={t7} size="large">{t8}</IconButton>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const backButton = t9;
  let leftButton = closeButton;
  if (isCompactMode && isFieldShown) {
    leftButton = backButton;
  }
  let t10;
  let t11;
  if ($[15] !== isCompactMode) {
    t10 = () => {
      toggleField(!isCompactMode);
    };
    t11 = [isCompactMode];
    $[15] = isCompactMode;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  useEffect(t10, t11);
  let t12;
  if ($[18] !== isCompactMode || $[19] !== isFieldShown || $[20] !== translations) {
    t12 = <div className={classes.formContainer}><SearchForm id="people-search" translations={translations} isCompactMode={isCompactMode} isFieldShown={isFieldShown} /></div>;
    $[18] = isCompactMode;
    $[19] = isFieldShown;
    $[20] = translations;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== hasEmptyPeopleList || $[23] !== isCompactMode || $[24] !== isFieldShown || $[25] !== translations) {
    t13 = isCompactMode && !isFieldShown && !hasEmptyPeopleList && <IconButton aria-label={translations.toggleSearchFieldLabel({
      isFieldShown
    })} color="inherit" className={classes.mobileSearchButton} onClick={() => {
      toggleField(_temp4);
    }} size="large"><SearchIcon /></IconButton>;
    $[22] = hasEmptyPeopleList;
    $[23] = isCompactMode;
    $[24] = isFieldShown;
    $[25] = translations;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== leftButton || $[28] !== t12 || $[29] !== t13) {
    t14 = <div className={classes.top}>{leftButton}{t12}{t13}</div>;
    $[27] = leftButton;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== onConfirmSelected || $[32] !== selected || $[33] !== translations) {
    t15 = selected?.id && <SelectedPeople onConfirm={onConfirmSelected} translations={translations} people={selected} />;
    $[31] = onConfirmSelected;
    $[32] = selected;
    $[33] = translations;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15) {
    t16 = <div role="region" aria-live="polite">{t15}</div>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t16) {
    t17 = <StyledPaper className={classes.root} elevation={2} square={true}>{t14}{t16}</StyledPaper>;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp4(state_0) {
  return !state_0;
}
function _temp3(state) {
  return !state;
}
function _temp2() {}
function _temp() {}